// #region Imports
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "react-datepicker/dist/react-datepicker.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
// #endregion

// #region selectors
import {
  useAuthPermiso,
  useControlEscolaroNotificacion,
  useControlEscolaroPersona,
  useControlEscolaroAlumno,
  useCampusVirtualIdCampus,
  useCampusVirtualIsLoading,
  useCampusVirtualOptionsListaCampus,
  useCampusVirtualOptionsListaProgramasAcademicos,
  useCampusVirtualOptionsListaPlanesEstudio,
  useCampusVirtualOptionsListaTurnos,
  useCampusVirtualOptionsListaTrayectorias,
  useCampusVirtualOptionsListaStatus,
  useAuthIdPersonaAuthenticated,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  getCampusVirtualCampus,
  getCampusVirtualCarreras,
  getCampusVirtualPlanes,
  getCampusVirtualTurnos,
  getCampusVirtualTrayectorias,
  getCampusVirtualStatus,
  getControlEscolarGetAlumno as onGetControlEscolarGetAlumno,
  putControlEscolarPutAlumno,
  ControlEscolarUnsetNotificacion,
} from "store/actions"
// #endregion

const DatosAcademicos = ({ oAlumnoLight, isEdit }) => {
  //console.log("Iniciando el componente: DatosAcademicos ", oAlumnoLight)
  //
  // #region Init
  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "Y-m-d",
    enableTime: false,
  }
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region const-selectors

  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const notificacion = useControlEscolaroNotificacion()
  const oPersona = useControlEscolaroPersona()
  const oAlumnoDA = useControlEscolaroAlumno()
  const idCampusCurrent = useCampusVirtualIdCampus()
  const isLoading = useCampusVirtualIsLoading()
  const optionsCampus = useCampusVirtualOptionsListaCampus()
  const optionsProgramasAcademicos =
    useCampusVirtualOptionsListaProgramasAcademicos()
  const optionsPlanesEstudio = useCampusVirtualOptionsListaPlanesEstudio()
  const optionsTurnos = useCampusVirtualOptionsListaTurnos()
  const optionsTrayectorias = useCampusVirtualOptionsListaTrayectorias()
  const optionsStatus = useCampusVirtualOptionsListaStatus()

  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  // #endregion

  // #region useRef
  const flatpickrRef = useRef(null)
  // #endregion

  // #region Internal States
  const [id_Campus_Alumno_Current, set_id_Campus_Alumno_Current] = useState(-1)
  const [id_Plan_Alumno_Current, set_id_Plan_Alumno_Current] = useState(-1)
  // #endregion

  // #region useEffects

  useEffect(() => {
    //console.log("useEffect::oAlumnoLight: ", oAlumnoLight)
    dispatch(
      onGetControlEscolarGetAlumno({
        nombreSolicitud: "getoalumno",
        idAlumno: oAlumnoLight.id_Alumno,
      })
    )
    //console.log("dispatching: getCampusVirtualCampus")
    dispatch(
      getCampusVirtualCampus({
        nombreSolicitud: "getarbollistacampi",
      })
    )
    //console.log("dispatching: getCampusVirtualCarreras")
    dispatch(
      getCampusVirtualCarreras({
        nombreSolicitud: "getarbolprogramasacademicosxidcampus",
        idCampus: idCampusCurrent,
      })
    )
    //console.log("dispatching: getCampusVirtualPlanes")
    dispatch(
      getCampusVirtualPlanes({
        nombreSolicitud: "getarbolplanesestudioxidcampus",
        idCampus: idCampusCurrent,
        idProgramaAcademico: 0,
      })
    )
    //console.log("dispatching: getCampusVirtualTurnos")
    dispatch(
      getCampusVirtualTurnos({
        nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
        idCampus: idCampusCurrent,
        idPlanEstudio: 0,
      })
    )
    //console.log("dispatching: getCampusVirtualStatus")
    dispatch(
      getCampusVirtualStatus({
        nombreSolicitud: "getlistaStatus",
      })
    )
  }, [dispatch, oAlumnoLight])

  useEffect(() => {
    console.log("useEffect::oAlumnoDA: ", oAlumnoDA)
    //console.log("dispatching: getCampusVirtualTrayectorias")
    dispatch(
      getCampusVirtualTrayectorias({
        nombreSolicitud: "getarboltrayectoriaxdcampusxidplanestudio",
        idCampus: idCampusCurrent,
        idPlanEstudio: oAlumnoDA.id_Plan_Estudio,
      })
    )
  }, [oAlumnoDA])

  useEffect(() => {
    //console.log("optionsCampus: ", optionsCampus)
  }, [optionsCampus])

  useEffect(() => {
    //console.log("optionsPlanesEstudio: ", optionsPlanesEstudio)
  }, [optionsPlanesEstudio])

  useEffect(() => {
    //console.log("optionsTurnos: ", optionsTurnos)
  }, [optionsTurnos])

  useEffect(() => {
    //console.log("optionsStatus: ", optionsStatus)
  }, [optionsStatus])

  useEffect(() => {
    //console.log("optionsTrayectorias: ", optionsTrayectorias)
    // if (optionsTrayectorias.length == 1) {
    //   oAlumnoDA.id_Trayectoria = optionsTrayectorias[0].value
    // }
  }, [optionsTrayectorias])

  useEffect(() => {
    if (notificacion && notificacion.length) {
      dispatch(ControlEscolarUnsetNotificacion())
    }
  }, [dispatch, notificacion])

  useEffect(() => {
    //console.log("useEffect::oAlumnoLight", oAlumnoLight)
    // console.log("dispatching: getarbollistacampi")
    // dispatch(
    //   getCampusVirtualCampus({
    //     nombreSolicitud: "getarbollistacampi",
    //   })
    // )
    // console.log("dispatching: getarbolplanesestudioxidcampus")
    // dispatch(
    //   getCampusVirtualCampus({
    //     nombreSolicitud: "getarbolplanesestudioxidcampus",
    //     idCampus: idCampusCurrent,
    //     idProgramaAcademico: 0,
    //   })
    // )
    // console.log("dispatching: getarbolturnosxidcampusxidplanestudio")
    // dispatch(
    //   getCampusVirtualCampus({
    //     nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
    //     idCampus: idCampusCurrent,
    //     idPlanEstudio: oAlumnoLight.id_Plan_Estudio,
    //   })
    // )
    // console.log("dispatching: getarboltrayectoriaxdcampusxidplanestudio")
    // dispatch(
    //   getCampusVirtualCampus({
    //     nombreSolicitud: "getarboltrayectoriaxdcampusxidplanestudio",
    //     idCampus: idCampusCurrent,
    //     idPlanEstudio: oAlumnoLight.id_Plan_Estudio,
    //   })
    // )
  }, [])

  // #endregion

  //#region Formik form

  const {
    id_Alumno = -1,
    id_Persona = -1,
    id_Campus = -1,
    id_Programa_Academico = -1,
    id_Plan_Estudio = -1,
    id_Status = -1,
    id_Turno = -1,
    id_Turno_Extra = oAlumnoDA?.Lista_Turnos?.length > 1
      ? oAlumnoDA.Lista_Turnos[1].id_Turno
      : -1,
    id_Trayectoria = -1,
    id_Kardex = -1,
    Fecha_Inscripcion = "2000-01-01",
    En_Proceso_Revalidacion_Materias = false,
    Fecha_Inscripcion_SE = "2000-01-01",
    Fecha_Inicio_Clases = "2000-01-01",
    Revoe = "",
    Matricula_SE = "",
    Matricula_Inea = "",
    Matricula_Interna = "",
    Es_Oficial = false,
    Curso_Propedeutico = false,
    Importe_Inscripcion = 0.0,
    Importe_Mensualidad = 0.0,
    Responsable = "",
    Reingreso = false,
    Fecha_Reingreso = "2000-01-01",
  } = oAlumnoDA

  const initialValues = {
    id_Alumno,
    id_Persona,
    id_Campus,
    id_Programa_Academico,
    id_Plan_Estudio,
    id_Status,
    id_Turno,
    id_Turno_Extra,
    id_Trayectoria,
    id_Kardex,
    Fecha_Inscripcion: Fecha_Inscripcion.split("T")[0],
    En_Proceso_Revalidacion_Materias,
    Fecha_Inscripcion_SE: Fecha_Inscripcion_SE.split("T")[0],
    Fecha_Inicio_Clases: Fecha_Inicio_Clases.split("T")[0],
    Rvoe: Revoe,
    Matricula_SE,
    Matricula_Inea,
    Matricula_Interna,
    Es_Oficial,
    Curso_Propedeutico,
    Importe_Inscripcion,
    Importe_Mensualidad,
    Responsable,
    Reingreso,
    Fecha_Reingreso: Fecha_Reingreso.split("T")[0],
  }

  const handleCampusChange = event => {
    //console.log("handleCampusChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const id_Campus = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, id_Campus)

    //console.log("dispatching: getCampusVirtualCarreras")
    dispatch(
      getCampusVirtualCarreras({
        nombreSolicitud: "getarbolprogramasacademicosxidcampus",
        idCampus: id_Campus,
      })
    )
    //console.log("dispatching: getCampusVirtualPlanes")
    dispatch(
      getCampusVirtualPlanes({
        nombreSolicitud: "getarbolplanesestudioxidcampus",
        idCampus: id_Campus,
        idProgramaAcademico: 0,
      })
    )
    //console.log("dispatching: getCampusVirtualTurnos")
    dispatch(
      getCampusVirtualTurnos({
        nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
        idCampus: id_Campus,
        idPlanEstudio: 0,
      })
    )
  }

  const handleProgramaAcademicoChange = event => {
    //console.log("handleProgramaAcademicoChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)

    //console.log("dispatching: getCampusVirtualPlanes")
    dispatch(
      getCampusVirtualPlanes({
        nombreSolicitud: "getarbolplanesestudioxidcampus",
        idCampus: formik.values.id_Campus,
        idProgramaAcademico: value,
      })
    )
  }

  const handlePlanEstudioChange = event => {
    //console.log("handlePlanEstudioChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)

    console.log("dispatching: getCampusVirtualTurnos")
    dispatch(
      getCampusVirtualTurnos({
        nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
        idCampus: formik.values.id_Campus,
        idPlanEstudio: event.target.value,
      })
    )

    console.log("dispatching: getCampusVirtualTrayectorias")
    dispatch(
      getCampusVirtualTrayectorias({
        nombreSolicitud: "getarboltrayectoriaxdcampusxidplanestudio",
        idCampus: formik.values.id_Campus,
        idPlanEstudio: event.target.value,
      })
    )
  }

  const handleUpperCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toUpperCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const handleLowerCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toLowerCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const validationSchema = Yup.object({})

  const onSubmit = values => {
    console.log("Form data", values)
    dispatch(
      putControlEscolarPutAlumno({
        nombreSolicitud: "updateoalumno",
        oAlumno: values,
        idAlumno: values.id_Alumno,
        id_Turno_Extra: values.id_Turno_Extra,
        idPersona: idPersonaAuthenticated,
      })
    )
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
  })

  // #endregion

  return (
    <React.Fragment>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        {/* Campus, Turno, id_Alumno */}
        <Row>
          {/* Campus */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputCampus">Campus</Label>
              {!isLoading ? (
                <select
                  name="id_Campus"
                  id="formrow-InputCampus"
                  className="form-control"
                  value={formik.values.id_Campus}
                  onChange={handleCampusChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsCampus.map(option => {
                    return (
                      <option
                        key={`id_Campus_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Campus && formik.touched.id_Campus ? (
                <span className="text-danger">{formik.errors.id_Campus}</span>
              ) : null}
            </div>
          </Col>
          {/* Turno */}
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-InputTurno">Turno</Label>
              {!isLoading ? (
                <select
                  name="id_Turno"
                  id="formrow-InputTurno"
                  className="form-control"
                  value={formik.values.id_Turno}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsTurnos.map(option => {
                    return (
                      <option
                        key={`id_Turno_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Turno && formik.touched.id_Turno ? (
                <span className="text-danger">{formik.errors.id_Turno}</span>
              ) : null}
            </div>
          </Col>
          {/* id_Alumno */}{" "}
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-id_Alumno-Input">id Alumno</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="id_Alumno"
                  className="form-control"
                  id="formrow-id_Alumno-Input"
                  placeholder="id_Alumno"
                  disabled={true}
                  value={formik.values.id_Alumno}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.id_Alumno && formik.errors.id_Alumno
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Alumno && formik.touched.id_Alumno ? (
                <FormFeedback type="invalid">
                  {formik.errors.id_Alumno}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Programa Académico, TurnoExtra, Rvoe */}
        <Row>
          {/* Programa Académico */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputPrograma_Academico">
                Programa Académico
              </Label>
              {!isLoading ? (
                <select
                  name="id_Programa_Academico"
                  id="formrow-InputPrograma_Academico"
                  className="form-control"
                  value={formik.values.id_Programa_Academico}
                  onChange={handleProgramaAcademicoChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsProgramasAcademicos.map(option => {
                    return (
                      <option
                        key={`id_Programa_Academico_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Programa_Academico &&
              formik.touched.id_Programa_Academico ? (
                <span className="text-danger">
                  {formik.errors.id_Programa_Academico}
                </span>
              ) : null}
            </div>
          </Col>
          {/* Turno Extra */}
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-InputTurnoExtra">Turno Extra</Label>
              {!isLoading ? (
                <select
                  name="id_Turno_Extra"
                  id="formrow-InputTurnoExtra"
                  className="form-control"
                  value={formik.values.id_Turno_Extra}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsTurnos.map(option => {
                    return (
                      <option
                        key={`id_Turno_Extra_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Turno_Extra && formik.touched.id_Turno_Extra ? (
                <span className="text-danger">
                  {formik.errors.id_Turno_Extra}
                </span>
              ) : null}
            </div>
          </Col>
          {/* Rvoe */}
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Rvoe-Input">Rvoe</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Rvoe"
                  className="form-control"
                  id="formrow-Rvoe-Input"
                  placeholder="Rvoe"
                  disabled={true}
                  value={formik.values.Rvoe}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Rvoe && formik.errors.Rvoe ? true : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Rvoe && formik.touched.Rvoe ? (
                <FormFeedback type="invalid">{formik.errors.Rvoe}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Plan Estudio, Grupo, Matricula, id_Kardex */}
        <Row>
          {/* Plan Estudio */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputPlan_Estudio">Plan Estudio</Label>
              {!isLoading ? (
                <select
                  name="id_Plan_Estudio"
                  id="formrow-InputPlan_Estudio"
                  className="form-control"
                  value={formik.values.id_Plan_Estudio}
                  onChange={handlePlanEstudioChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsPlanesEstudio.map(option => {
                    return (
                      <option
                        key={`id_Plan_Estudio_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Plan_Estudio &&
              formik.touched.id_Plan_Estudio ? (
                <span className="text-danger">
                  {formik.errors.id_Plan_Estudio}
                </span>
              ) : null}
            </div>
          </Col>

          {/* Grupo */}
          <Col md={2}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Matricula_Inea-Input">Grupo</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Matricula_Inea"
                  className="form-control"
                  id="formrow-Matricula_Inea-Input"
                  placeholder="Matricula_Inea"
                  value={formik.values.Matricula_Inea}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Matricula_Inea &&
                    formik.errors.Matricula_Inea
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Matricula_Inea && formik.touched.Matricula_Inea ? (
                <FormFeedback type="invalid">
                  {formik.errors.Matricula_Inea}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          {/* Matricula SE */}
          <Col md={2}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Matricula_SE-Input">Matricula_SE</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Matricula_SE"
                  className="form-control"
                  id="formrow-Matricula_SE-Input"
                  placeholder="Matricula_SE"
                  value={formik.values.Matricula_SE}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Matricula_SE && formik.errors.Matricula_SE
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Matricula_SE && formik.touched.Matricula_SE ? (
                <FormFeedback type="invalid">
                  {formik.errors.Matricula_SE}
                </FormFeedback>
              ) : null}
            </div>
          </Col>

          {/* id_kardex */}
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-id_Kardex-Input">id Kardex</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="id_Kardex"
                  className="form-control"
                  id="formrow-id_Kardex-Input"
                  placeholder="id_Kardex"
                  disabled={true}
                  value={formik.values.id_Kardex}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.id_Kardex && formik.errors.id_Kardex
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Kardex && formik.touched.id_Kardex ? (
                <FormFeedback type="invalid">
                  {formik.errors.id_Kardex}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Trayectoria, Generacion */}
        <Row>
          {/* Trayectoria */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputTrayectoria">Trayectoria</Label>
              {!isLoading ? (
                <select
                  name="id_Trayectoria"
                  id="formrow-InputTrayectoria"
                  className="form-control"
                  value={formik.values.id_Trayectoria}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsTrayectorias.map(option => {
                    return (
                      <option
                        key={`id_Trayectoria_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Trayectoria && formik.touched.id_Trayectoria ? (
                <span className="text-danger">
                  {formik.errors.id_Trayectoria}
                </span>
              ) : null}
            </div>
          </Col>
          {/* Generación */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Matricula_Interna-Input">
                Generación
              </Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Matricula_Interna"
                  className="form-control"
                  id="formrow-Matricula_Interna-Input"
                  placeholder="Matricula_Interna"
                  value={formik.values.Matricula_Interna}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Matricula_Interna &&
                    formik.errors.Matricula_Interna
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Matricula_Interna &&
              formik.touched.Matricula_Interna ? (
                <FormFeedback type="invalid">
                  {formik.errors.Matricula_Interna}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Status Académico, Fecha de Reingreso */}
        <Row>
          {/* id_Status */}{" "}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputStatus">Status Académico</Label>
              {!isLoading ? (
                <select
                  name="id_Status"
                  id="formrow-InputStatus"
                  className="form-control"
                  value={formik.values.id_Status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {optionsStatus.map(option => {
                    return (
                      <option
                        key={`id_Status_${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Status && formik.touched.id_Status ? (
                <span className="text-danger">{formik.errors.id_Status}</span>
              ) : null}
            </div>
          </Col>{" "}
          {/* Fecha Reingreso */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Reingreso">
                Fecha de Reingreso
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Reingreso"
                    className="form-control d-block"
                    id="formrow-Fecha_Reingreso"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Reingreso}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Reingreso", dateStr)
                    }}
                    disabled={true}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Reingreso &&
                      formik.errors.Fecha_Reingreso
                        ? true
                        : false
                    }
                  />
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Reingreso &&
              formik.touched.Fecha_Reingreso ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Reingreso}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Fecha Inscripción, Fecha Alta SE, Fecha Inicio de Clases */}
        <Row>
          {/* Fecha Inscripción */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Inscripcion">
                Fecha de Inscripcion
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Inscripcion"
                    className="form-control d-block"
                    id="formrow-Fecha_Inscripcion"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Inscripcion}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Inscripcion", dateStr)
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Inscripcion &&
                      formik.errors.Fecha_Inscripcion
                        ? true
                        : false
                    }
                  />
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Inscripcion &&
              formik.touched.Fecha_Inscripcion ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Inscripcion}
                </FormFeedback>
              ) : null}
            </div>
          </Col>{" "}
          {/* Fecha Alta SE */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Inscripcion_SE">
                Fecha de Inscripción Secretaría
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Inscripcion_SE"
                    className="form-control d-block"
                    id="formrow-Fecha_Inscripcion_SE"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Inscripcion_SE}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Inscripcion_SE", dateStr)
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Inscripcion_SE &&
                      formik.errors.Fecha_Inscripcion_SE
                        ? true
                        : false
                    }
                  />
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Inscripcion_SE &&
              formik.touched.Fecha_Inscripcion_SE ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Inscripcion_SE}
                </FormFeedback>
              ) : null}
            </div>
          </Col>{" "}
          {/* Fecha Inicio de Clases */}
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Inicio_Clases">
                Fecha de Inicio_Clases
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Inicio_Clases"
                    className="form-control d-block"
                    id="formrow-Fecha_Inicio_Clases"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Inicio_Clases}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Inicio_Clases", dateStr)
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Inicio_Clases &&
                      formik.errors.Fecha_Inicio_Clases
                        ? true
                        : false
                    }
                  />
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Inicio_Clases &&
              formik.touched.Fecha_Inicio_Clases ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Inicio_Clases}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* CheckBoxes - Grado superior, Alta Oficial, Curso Propedéutico */}
        <Row>
          {/* Grado superior */}
          <Col md={2}>
            <div className="mb-3">
              {!isLoading ? (
                <>
                  <Input
                    type="checkbox"
                    className="form-check-Input"
                    id="formrow-customCheck"
                    name="En_Proceso_Revalidacion_Materias"
                    checked={formik.values.En_Proceso_Revalidacion_Materias}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.En_Proceso_Revalidacion_Materias &&
                      formik.errors.En_Proceso_Revalidacion_Materias
                        ? true
                        : false
                    }
                  />
                  <Label
                    className="form-check-Label"
                    htmlFor="formrow-customCheck"
                  >
                    {" "}
                    Grado superior
                  </Label>
                </>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.En_Proceso_Revalidacion_Materias &&
              formik.touched.En_Proceso_Revalidacion_Materias ? (
                <FormFeedback type="invalid">
                  {formik.errors.En_Proceso_Revalidacion_Materias}
                </FormFeedback>
              ) : null}
            </div>
          </Col>{" "}
          {/* Alta Oficial */}
          <Col md={2}>
            <div className="mb-3">
              {!isLoading ? (
                <>
                  <Input
                    type="checkbox"
                    className="form-check-Input"
                    id="formrow-Es_Oficial"
                    name="Es_Oficial"
                    checked={formik.values.Es_Oficial}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Es_Oficial && formik.errors.Es_Oficial
                        ? true
                        : false
                    }
                  />
                  <Label
                    className="form-check-Label"
                    htmlFor="formrow-Es_Oficial"
                  >
                    {" "}
                    Es oficial
                  </Label>
                </>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Es_Oficial && formik.touched.Es_Oficial ? (
                <FormFeedback type="invalid">
                  {formik.errors.Es_Oficial}
                </FormFeedback>
              ) : null}
            </div>
          </Col>{" "}
          {/* Curso Propedéutico */}
          <Col md={2}>
            <div className="mb-3">
              {!isLoading ? (
                <>
                  <Input
                    type="checkbox"
                    className="form-check-Input"
                    id="formrow-Curso_Propedeutico"
                    name="Curso_Propedeutico"
                    checked={formik.values.Curso_Propedeutico}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Curso_Propedeutico &&
                      formik.errors.Curso_Propedeutico
                        ? true
                        : false
                    }
                  />
                  <Label
                    className="form-check-Label"
                    htmlFor="formrow-Curso_Propedeutico"
                  >
                    {" "}
                    Curso Propedéutico
                  </Label>
                </>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Curso_Propedeutico &&
              formik.touched.Curso_Propedeutico ? (
                <FormFeedback type="invalid">
                  {formik.errors.Curso_Propedeutico}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-2">
          {isEdit ? (
            <button
              type="submit"
              className="btn btn-primary w-md"
              disabled={!formik.isValid || !isAdministradorGeneral}
            >
              Enviar
            </button>
          ) : null}
        </div>
      </Form>
    </React.Fragment>
  )
}

export default DatosAcademicos
